<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid add-client">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <div class="mb-2 rounded p-2" style="background-color: #f5f5f5;">
              <router-link
                :to="{ name: 'ManageClients' }"
                class="d-inline"
                style="font-weight: normal;"
              >
                Clients
              </router-link>
              <p class="d-inline pl-1 pr-1">/</p>
              <router-link
                :to="{}"
                class="d-inline"
                style="font-weight: normal;"
              >
                Edit client
              </router-link>
              <p class="d-inline pl-1 pr-1">/</p>
              <router-link
                :to="{}"
                class="d-inline"
                style="font-weight: normal;"
              >
                {{ clientName }}
              </router-link>
            </div>
            <h4>Edit Client</h4>
            <hr />
            <editClientForm></editClientForm>
            <router-view />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import EditClientForm from "./EditClientForm.vue";

export default {
  name: "EditClient",
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    editClientForm: EditClientForm,
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "manageClients",
        activeMenu: this.activeMenu ? this.activeMenu : "clientusermanagement",
      });
    },
  },

  computed: {
    clientName() {
      return this.$store.state.manageClients.client.name;
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>
<style lang="scss" scoped>
.add-client {
  //   margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}
.marginAll {
  margin: 10px;
}

html,
body {
  height: 100%;
}
</style>
